import React from "react";

export default function TestimonialsSectionTestimonials3() {
  return (
    <React.Fragment>
      <>
        <section className="relative pt-24 pb-32 bg-white overflow-hidden">
          <img
            className="absolute top-0 left-0"
            src="flaro-assets/images/testimonials/gradient.svg"
            alt=""
          />
          <img
            className="absolute bottom-0 right-0"
            src="flaro-assets/images/testimonials/gradient2.svg"
            alt=""
          />
          <div className="relative z-10 container px-4 mx-auto">
            <h2 className="mb-16 text-6xl md:text-7xl font-bold font-heading text-center tracking-px-n leading-tight">
              ¿Qué piensan nuestros clientes?
            </h2>
            <div className="flex flex-wrap -m-3">
              <div className="w-full md:w-1/2 lg:w-1/3 p-3">
                <div className="p-6 h-full bg-white bg-opacity-60 border rounded-4xl">
                  <div className="flex flex-col justify-between h-full">
                    <div className="mb-5 block">
                      <div className="mb-4">
                        <h3 className="font-semibold leading-normal">
                          Michael Quiñones
                        </h3>
                      </div>
                      <p className="text-lg font-medium">
                        “Novovida fue clave en mi cambio fisico pero sobre todo, en la perspectiva que tengo sobre mi mismo. Sin duda alguna cambio no solo mi salud fisica, si no que tambien la mental.”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 lg:w-1/3 p-3">
                <div className="p-6 h-full bg-white bg-opacity-60 border rounded-4xl">
                  <div className="flex flex-col justify-between h-full">
                    <div className="mb-5 block">
                      <div className="mb-4">
                        <h3 className="font-semibold leading-normal">
                          Yamilis Martinez
                        </h3>
                      </div>
                      <p className="text-lg font-medium">
                        “Novovida, me ha ayudado con mi salud mental, en cómo hacer mis comidas diarias y sobre todo me ha regalado una bonita familia.”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 lg:w-1/3 p-3">
                <div className="p-6 h-full bg-white bg-opacity-60 border rounded-4xl">
                  <div className="flex flex-col justify-between h-full">
                    <div className="mb-5 block">
                      <div className="mb-4">
                        <h3 className="font-semibold leading-normal">
                          Viankaliz Santos
                        </h3>
                      </div>
                      <p className="text-lg font-medium">
                        “Equipamiento moderno y variado, personal calificado y excelente ambiente.”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 lg:w-1/3 p-3">
                <div className="p-6 h-full bg-white bg-opacity-60 border rounded-4xl">
                  <div className="flex flex-col justify-between h-full">
                    <div className="mb-5 block">
                      <div className="mb-4">
                        <h3 className="font-semibold leading-normal">
                          Jailene Alicea Ramos
                        </h3>
                      </div>
                      <p className="text-lg font-medium">
                        “Coach Abner ha demostrado ser un excelente entrenador físico. El esfuerzo y dedicación por ayudarnos a llegar a la meta es excepcional.”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 lg:w-1/3 p-3">
                <div className="p-6 h-full bg-white bg-opacity-60 border rounded-4xl">
                  <div className="flex flex-col justify-between h-full">
                    <div className="mb-5 block">
                      <div className="mb-4">
                        <h3 className="font-semibold leading-normal">
                          Jose Vidal
                        </h3>
                      </div>
                      <p className="text-lg font-medium">
                        “Su experiencia, compromiso y conocimiento me han impulsado a alcanzar niveles que nunca creí posibles. Gracias cada entrenador y personal por su liderazgo, entrega y pasión!!”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/2 lg:w-1/3 p-3">
                <div className="p-6 h-full bg-white bg-opacity-60 border rounded-4xl">
                  <div className="flex flex-col justify-between h-full">
                    <div className="mb-5 block">
                      <div className="mb-4">
                        <h3 className="font-semibold leading-normal">
                          Joselyn Vega
                        </h3>
                      </div>
                      <p className="text-lg font-medium">
                        “Los entrenadores son muy profesionales, comprometidos y siempre están muy dispuestos a enseñarte a usar una maquina y/ó como realizar un ejercicio sin que te puedas lastimar.”
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
}
